import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { getFocus } from '../ChatApp/selectors';

import styles from './styles';
import messages from './messages';

class Footer extends PureComponent {
  constructor(props) {
    super(props);

    this.footerAnchor = null;
  }
  componentDidUpdate() {
    const { elInFocus } = this.props;

    if (elInFocus === 'lastFocusableElement') {
      this.footerAnchor.focus();
    }
  }
  render() {
    const { intl } = this.props;

    let target = 'https://www.kustomer.com';
    if (window && window.location && window.location.host) {
      target = `${target}?refUrl=${window.location.host}`;
    }
    return (
      <div style={styles.wrapper}>
        <div>
          <a
            id="lastFocusableElement"
            ref={element => (this.footerAnchor = element)}
            tabIndex="0"
            href={target}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            aria-label={intl.formatMessage(messages.aria_label_visit_kustomer_link)}
          >
            <i aria-hidden="true" style={styles.icon} /> {intl.formatMessage(messages.footer_brand)}
          </a>
        </div>
      </div>
    );
  }
}

Footer.propTypes = {
  intl: intlShape.isRequired,
  elInFocus: PropTypes.string,
};

Footer.defaultProps = {
  elInFocus: '',
};

const mapStateToProps = state => {
  return {
    elInFocus: getFocus(state),
  };
};

export const intlComponent = injectIntl(Radium(Footer), { withRef: true });
export default connect(mapStateToProps)(intlComponent);
